import { axiosInstance } from ".."

const applyCustomerWallet = async (id,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`/internal/wallet/apply/${id}`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default applyCustomerWallet;